import React from 'react';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';

function TableHeader({ columns, handleSortClick, currentSort }) {
  const isSortedAsc  = (key) => currentSort === `asc_${key}`;
  const isSortedDesc = (key) => currentSort === `desc_${key}`;

  return (
    <thead>
      <tr>
        {columns.map((column) => {
          const sortKey = column.sortColumn || column.id; // fall back to id
          return (
            <th
              key={column.id}
              scope="col"
              className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
            >
              <a
                href="#"
                className="group inline-flex"
                onClick={() => handleSortClick(sortKey)}
              >
                {column.name}
                {isSortedAsc(sortKey)  && <ChevronUpIcon   className="ml-2 h-5 w-5" />}
                {isSortedDesc(sortKey) && <ChevronDownIcon className="ml-2 h-5 w-5" />}
              </a>
            </th>
          );
        })}
      </tr>
    </thead>
  );
}

export default TableHeader;

